import apiService from '../../../../services/api';
import { Application } from '../model/JobApplicationsModel';

export const JobApplicationsApi = {
  getApplications: async (params: {
    status?: string;
    limit?: number;
    offset?: number;
  }): Promise<{
    applications: Application[];
    total: number;
    has_more: boolean;
    status_summary?: Record<string, number>;
  }> => {
    const searchParams = new URLSearchParams();

    if (params.status) searchParams.append('status', params.status);
    if (params.limit) searchParams.append('limit', String(params.limit));
    if (params.offset !== undefined) searchParams.append('offset', String(params.offset));

    const url = `/candidate/applications?${searchParams.toString()}`;
    
    const res = await apiService.get(url);

    return {
      applications: res.data.applications || [],
      total: res.data.total || 0,
      has_more: res.data.has_more || false,
      status_summary: res.data.status_summary
    };
  },

  getApplicationById: async (id: string): Promise<Application> => {
    const res = await apiService.get(`/candidate/applications/${id}`);
    return res.data;
  },

  withdrawApplication: async (applicationId: string): Promise<void> => {
    await apiService.post(
      `/applications/my-applications/${applicationId}/withdraw`
    );
  },
};